<template>
    <div class="key-value-pairs" style="width: 100%">
        <table
            v-for="(field, index) in internalValue"
            :key="'field-' + index"
            class="field-table"
        >
            <tr>
                <td><label>{{ t('inputs-keyvalue-field') }}</label></td>
                <td>
                    <input
                        type="text"
                        v-model="internalValue[index].key"
                        class="form-control"
                        :placeholder="t('inputs-keyvalue-placeholder_key')"
                    />
                </td>
            </tr>
            <tr>
                <td><label>{{ t('inputs-keyvalue-value') }}</label></td>
                <td>
                    <textarea
                        v-if="variant === 'large'"
                        v-model="internalValue[index].value"
                        class="form-control"
                        :placeholder="t('inputs-keyvalue-placeholder_value')"
                    />
                    <input
                        v-else
                        type="text"
                        v-model="internalValue[index].value"
                        class="form-control"
                        :placeholder="t('inputs-keyvalue-placeholder_value_template')"
                    />
                </td>
            </tr>
        </table>
        <button class="btn btn-primary" @click.prevent="addField">
            {{ t('inputs-keyvalue-add_field') }}
        </button>
    </div>
</template>

<script>
export default {
    name: "keyvalue",
    props: {
        variant: {
            type: String,
            default: "default",
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            internalValue: this.value ? [...this.value] : [],
        };
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        addField() {
            this.internalValue.push({key: "", value: ""});
            this.updateValue();
        },
        updateValue() {
            this.$emit("input", this.internalValue);
        },
    },
    watch: {
        internalValue: {
            deep: true,
            handler() {
                this.updateValue();
            },
        },
        value(newValue) {
            if (
                JSON.stringify(newValue) !== JSON.stringify(this.internalValue)
            ) {
                this.internalValue = [...newValue];
            }
        },
    },
};
</script>

<style scoped lang="scss">
.field-table {
    width: 100%;
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;

    td {
        padding: 0 0 10px;
    }
}
</style>
